import { API_PATHS } from "../constants/api-paths";
import { request } from "../core/api.client";

export const getAllNews = async (pageNo: number, newsPageDataLimit: number) => {
  const response = await request({
    method: "POST",
    url: `${API_PATHS.newsFeed}`,
    data: { page: pageNo, limit: newsPageDataLimit },
  });
  return response;
};

export const getBlockDeals = async (pageNo: number, newsPageDataLimit: number) => {
  const response = await request({
    method: "POST",
    url: `${API_PATHS.blockDeals}`,
    data: { page: pageNo, limit: newsPageDataLimit, exchId: 2 },
  });
  return response;
};

/**
 * Get Corporate Actions for News Feed
 * Note: Renamed to avoid conflict with corporateActions.service.ts
 */
export const getCorporateActionsNewsFeed = async (pageNo: number, newsPageDataLimit: number) => {
  const response = await request({
    method: "POST",
    url: `${API_PATHS.corporateAction}`,
    data: { page: pageNo, limit: newsPageDataLimit, exchId: 2, period: "month" },
  });
  return response;
};
